/*
 * A sick-cert/letter row in the Documents tab is really the generated PDF for a
 * `patientsickcert`/`patientletter` record — the generic `document` row carries no link back to
 * it, only the reverse (`documentId` on the letter/cert record itself). Matching on the
 * tenant-configurable document type name would be fragile (a practice can rename or re-seed its
 * types), so the row's own PDF document id is matched against the patient's letters and sick
 * certs instead, giving the record's own id to open it in the same editor Communications uses.
 */
export const findCommunicationsSource = (doc, { letters = [], sickCerts = [] } = {}) => {
  if (!doc?.id) return null;

  const letter = letters.find((item) => item.documentId === doc.id);
  if (letter) return { kind: "LETTER", id: letter.id };

  const sickCert = sickCerts.find((item) => item.documentId === doc.id);
  if (sickCert) return { kind: "SICK_CERT", id: sickCert.id };

  return null;
};
